<template>
    <div id="main">
        <div class="alert-wrapper">
            <alert-container :messages="msgs" />
        </div>

        <div class="page page-container page-catalogo">
            <div class="listing-header">
                <!-- TÍTULO E BREADCRUMB -->
                <div class="title-breadcrumb">
                    <h1 class="title">{{ $t('catalogo') }}</h1>
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a>{{ $t('vendas') }}</a>
                            </li>
                            <li>
                                <a>{{ $t('produto') }}</a>
                            </li>
                            <li>
                                <a aria-current="page">{{ $t('catalogo') }}</a>
                            </li>
                        </ul>
                    </nav>
                </div>

                <!-- BOTÕES DE AÇÃO -->
                <div class="form-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        tag="button"
                        @click="previousStep"
                        v-if="
                            tabSelecionada.currentStep == 2 ||
                            (tabSelecionada.currentStep == 3 && isFinished)
                        "
                    >
                        {{ $t('voltar') }}
                    </button>
                    <button
                        class="delete-btn"
                        type="button"
                        tag="button"
                        @click="
                            () => {
                                isCanceling = true;
                                sendCancel = true;
                            }
                        "
                        v-if="tabSelecionada.currentStep == 3 && !isFinished"
                    >
                        {{ $t('cancelar') }}
                        <button-loader :isSaving="isCanceling" />
                    </button>
                    <button
                        @click="nextStep(true)"
                        class="save-btn"
                        v-if="
                            permissao.create &&
                            tabSelecionada.currentStep < 3 &&
                            uploadedImages.length > 0
                        "
                    >
                        {{ $t('proximo') }}
                    </button>
                </div>
            </div>

            <!-- STEPS -->
            <div class="steps-box">
                <div class="steps-center">
                    <div
                        v-for="(step, i) in steps"
                        :key="i"
                        :class="
                            (step.tab ? 'step-circle' : 'background-dots') +
                            (tabSelecionada.currentStep >= step.currentStep ? ' active' : '')
                        "
                    >
                        <div data-toggle="tab" v-if="step.name">
                            <span>{{ step.name }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="step-content">
                <!-- Abas - cada passo do sistema -->
                <Upload
                    v-if="tabSelecionada.tab == steps[0].tab"
                    :images="uploadedImages"
                    @uploadedFiles="getUploadedImages"
                />

                <ListaImagens
                    v-if="tabSelecionada.tab == steps[2].tab"
                    :imageList="uploadedImages"
                    @photosUpdate="getImagesWithDetails"
                    @listEmpty="previousStep"
                />

                <Logs
                    v-if="tabSelecionada.tab == steps[4].tab"
                    :images="uploadedImages"
                    :sendCancel="sendCancel"
                    @sendCancel="sendCancel = $event"
                    @isCanceling="isCanceling = $event"
                    @isFinished="isFinished = $event"
                />
            </div>
        </div>
    </div>
</template>

<script>
// Componentes

// Abas
import Upload from '@/components/vendas/catalogo/abas/Upload.vue';
import ListaImagens from '@/components/vendas/catalogo/abas/ListaImagens';
import Logs from '@/components/vendas/catalogo/abas/Logs';

export default {
    beforeRouteLeave(to, from, next) {
        if (this.isChanged && !this.isFinished) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        Upload,
        ListaImagens,
        Logs,
    },
    data() {
        return {
            steps: [
                { name: '1', tab: 'upload', currentStep: 1 },
                { currentStep: 2 },
                { name: '2', tab: 'image-list', currentStep: 2 },
                { currentStep: 3 },
                { name: '3', tab: 'logs', currentStep: 3 },
            ],
            msgs: [],
            tabSelecionada: { tab: 'upload', currentStep: 1 },
            uploadedImages: [],
            canSave: false,
            sendCancel: false,
            isCanceling: false,
            isFinished: false,
            isChanged: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'produtos', 'ven-produto-catalogo');

        if (!this.permissao.read || !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'catalogo' },
            });
        }
    },
    methods: {
        previousStep() {
            if (this.tabSelecionada.currentStep == 3) {
                this.resetToStepOne();
            } else {
                this.tabSelecionada = this.steps.find(
                    (step) => step.currentStep == this.tabSelecionada.currentStep - 1 && step.tab
                );
            }
        },
        nextStep(validateStep) {
            if (this.tabSelecionada.currentStep == 2 && validateStep) {
                if (this.canSave) {
                    this.canUploadToServer();
                } else {
                    this.$root.showMessage(
                        'alert',
                        'msg-preencher-campos-obrigatorios-corretamente',
                        true
                    );
                }
            } else {
                this.tabSelecionada = this.steps.find(
                    (step) => step.currentStep == this.tabSelecionada.currentStep + 1 && step.tab
                );
            }
        },
        getUploadedImages(images) {
            this.uploadedImages = images;
            if (this.uploadedImages.length > 0) {
                this.nextStep(true);
            }
            this.isChanged = true;
        },
        getImagesWithDetails(images, canSave) {
            this.uploadedImages = images;
            this.canSave = canSave;
        },
        canUploadToServer() {
            this.$root.confirm({
                message: this.$t('msg-catalogo-upload-finalizacao'),
                onConfirm: (e) => this.nextStep(false),
            });
        },
        resetToStepOne() {
            this.tabSelecionada = { tab: 'upload', currentStep: 1 };
            this.uploadedImages = [];
            this.canSave = false;
            this.sendCancel = false;
            this.isCanceling = false;
            this.isCancelled = false;
            this.isFinished = false;
            this.isChanged = false;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
        margin-bottom: 20px;
    }

    .page-catalogo {
        .steps-box {
            display: flex;
            margin-bottom: 40px;
            margin-left: -60px;
            padding-left: 60px;
            margin-right: -20px;
            padding-right: 20px;
            justify-content: center;
            margin-top: 30px;

            .steps-center {
                width: 50%;
                display: flex;
                justify-content: space-between;
                position: relative;

                .step-circle {
                    border: 3px solid $dark-gray-color;
                    color: $dark-gray-color;
                    padding: 10px 18px;
                    border-radius: 80px;

                    &.active {
                        border-color: $primary-color-hover;
                        color: $primary-color-hover;

                        span {
                            color: $primary-color-hover;
                        }
                    }
                }

                > .step-circle:first-child {
                    padding: 10px 19px;
                }

                .background-dots {
                    flex-grow: 1;
                    border: none;
                    border-top: 3px dotted $dark-gray-color;
                    height: 0;
                    position: relative;
                    top: 50%;
                    margin: 0 4px;

                    &.active {
                        border-top: 3px dotted $primary-color-hover;
                    }
                }

                .catalogo-steps {
                    width: 100%;
                }
            }
        }

        .step-content {
            display: flex;
            margin: 5px;
        }
    }
}

@media only screen and (max-width: 760px) {
    .page-catalogo .steps-box .steps-center {
        width: 100%;
    }
}
</style>
